import request from "@/utils/request";

// 获取内控详情
export function queryInternalControlByType(type) {
  return request({
    url: `/opStandardInternalControl/getInfoByType/${type}`,
    method: "get",
  });
}

// 新增或编辑内控标准(供水厂净水厂共用)
export function adjustInternalControl(data) {
  return request({
    url: "/opStandardInternalControl/saveOrUpdateOpStandardInternal",
    method: "post",
    data,
  });
}
